  import { useParams } from "react-router-dom";
  import { useEffect, useState, useMemo } from "react";
  import { useBuscarPaciente } from "../Services/BusquedaPaciente";
  import { DataGrid } from "@mui/x-data-grid";
  import HistoryIcon from '@mui/icons-material/History';
  import WarningAmberIcon from '@mui/icons-material/WarningAmber';
  import {
    Avatar,
    Container,
    Typography,
    Box,
    Paper,
    CircularProgress,
    Card,
    Grid,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    Button,
    TextField,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody
  } from "@mui/material";
  import { TituloPrincipal, styleCarga, SubTitulo, buttonCancelar, buttonGuardar, InputBuscador, buttonCerrar } from "../Layouts/CustomStyles";
  import Logocolor from "../Image/Logo.png";
  import { DiseñoDataGrid } from "../Components/FuncionesGenerales/DataGrid";
  import { formatCLP } from "../Components/FuncionesGenerales/FormatoCLP";
  import { FormatRut } from "../Components/FuncionesGenerales/Rut";
  import { useGetSucursal } from "../Services/Sucursales";
  import { useGetProfesional } from "../Services/Profesional";
  import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import PaidIcon from "@mui/icons-material/Paid";
import { useUserSuperEmpresa } from "../Context/AuthContext";
  


  const BuscarPacienteIndex = () => {
    const { Usuario } = useUserSuperEmpresa();
    const roleId = Usuario?.id;
  const esRolLimitado = roleId === 2;

    const { id } = useParams();
    const { data, loading, error, buscarPaciente } = useBuscarPaciente();
    const { sucursales } = useGetSucursal();
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogText, setDialogText] = useState("");
    const { profesional } = useGetProfesional();
    const [openHistorial, setOpenHistorial] = useState(false);
    const [historialSeleccionado, setHistorialSeleccionado] = useState([]);
    const [deudorSeleccionado, setDeudorSeleccionado] = useState(null);
    const [openGeneralModal, setOpenGeneralModal] = useState(false);
    const [detalleGeneral, setDetalleGeneral] = useState(null);
    const [busqueda, setBusqueda] = useState("");
    
    const getEstadoIcon = (estado) => {
  switch (estado) {
    case "PROCESO":
      return <InfoIcon sx={{ color: "#e0a800", fontSize: 28 }} />;
    case "LIBERADO":
      return <CheckCircleIcon sx={{ color: "#28a745", fontSize: 28 }} />;
    case "NO PAGO":
      return <ErrorIcon sx={{ color: "#dc3545", fontSize: 28 }} />;
    case "PAGADO":
      return <PaidIcon sx={{ color: "#0d6efd", fontSize: 28 }} />;
    default:
      return <InfoIcon sx={{ color: "#6c757d", fontSize: 28 }} />;
  }
};


    const handleOpenGeneral = () => {
    if (!data) return;

    // 1. Episodios de ingresos
    const episodiosIngreso = data.ingresos?.map(i => i.paciente.episodio);

    // 2. Episodios SAP
    const episodiosSap = data.sap?.map(s => s.episodio);

    // Buscar coincidencias
    const episodiosCoincidentes = episodiosIngreso.filter(ep => episodiosSap.includes(ep));

    const detalles = episodiosCoincidentes.map(ep => ({
      episodio: ep,
      ingresos: data.ingresos.filter(i => i.paciente.episodio === ep),
      sap: data.sap.filter(s => s.episodio === ep),
    }));

    setDetalleGeneral(detalles);
    setOpenGeneralModal(true);
  };






  const handleOpenDialog = (text) => {
    setDialogText(text);
    setOpenDialog(true);
  };

  const handleOpenHistorial = (pagos, deudor) => {
  setHistorialSeleccionado(pagos || []);
  setDeudorSeleccionado(deudor || null);
  setOpenHistorial(true);
};



  const handleCloseHistorial = () => {
    setOpenHistorial(false);
    setHistorialSeleccionado([]);
  };


  useEffect(() => {
    if (id) {
      buscarPaciente(id);    // buscar el paciente automáticamente
    }
  }, [id]);

  // Obtener todos los deudores existentes
  const deudas = data?.ingresos
    ?.filter(i => i.deudor) // solo ingresos con deudor
    ?.map(i => Number(i.deudor.saldo_restante)) || [];

  // Sumar todos los saldos restantes
  const totalDeudaPaciente = deudas.reduce((acc, val) => acc + val, 0);

  const getSucursalName = (id, sucursales) => {
  const s = sucursales?.find(s => Number(s.id) === Number(id));
  return s ? s.name : "Sin sucursal";
};


  // Buscar nombre profesional usando el rut del SAP
  // Filtrar y asociar profesionales SAP con tabla profesional
  const profesionalesAtendidos = data?.sap
    ?.map((item) => {
      const match = profesional?.find(
        (pro) => pro.rut === item.rut_profesional
      );

      return {
        id: item.id,
        rut_profesional: item.rut_profesional,
        nombre_profesional: match ? match.nombre : item.nombre_profesional,
        fecha_atencion: item.fecha_inicio_prestacion,
        episodio: item.episodio,
      };
    }) || [];

  const columnsProfesionales = [
    { field: "rut_profesional", headerName: "RUT Profesional", width: 180 },
    { field: "nombre_profesional", headerName: "Nombre Profesional", width: 230 },
    { field: "fecha_atencion", headerName: "Fecha Atención", width: 180 },
    { field: "episodio", headerName: "Episodio", width: 150 },
  ];



  const rows = data?.ingresos?.map((item, index) => ({
    id: item.paciente.id,
    episodio: item.paciente.episodio,
    fecha: item.paciente.fecha,
    fecha_pago: item.paciente.fecha_pago,
    estado_paciente: item.paciente.estado_paciente,
    prevision: item.paciente.prevision,
    monto: item.paciente.monto,
    n_sesiones: item.paciente.n_sesiones,
    kine: item.paciente.kine,
    medico_tratante: item.paciente.medico_tratante,
    rut: item.paciente.rut,
    observaciones: item.paciente.observaciones || null,
    fecha_registro: item.paciente.fecha,
    estado_pago: item.paciente.estado_pago,
    sucursal: getSucursalName(item.paciente.branch_id, sucursales),
    pagos_deudores: item.pagos_deudores ?? [],
    deudor: item.deudor,
   }))
    ?.sort((a, b) => {
      // Más antiguo arriba
      return new Date(a.fecha_pago) - new Date(b.fecha_pago);
    }) || [];

  const columns = [


    { field: "fecha", headerName: "Fecha ingreso", width: 120 },
    {
      field: "episodio",
      headerName: "Episodio",
      width: 160,
      renderCell: (params) => {
        const episodio = params.row.episodio;
        const pagos = params.row.pagos_deudores;

        // Si no hay episodio → no mostrar nada
        if (!episodio) return null;

        // Si hay episodio pero NO historial → solo mostrar el episodio
        if (!pagos || pagos.length === 0) {
          return (
            <Typography sx={{ fontFamily: "Poppins" }}>
              {episodio}
            </Typography>
          );
        }

        // Si hay episodio + historial → mostrar ambos
        return (
          <Box sx={{ height: '50px', display: "flex", alignItems: "center", justifyContent: 'center', gap: 1 }}>
            <Typography sx={{ fontFamily: "Poppins" }}>{episodio}</Typography>

            <HistoryIcon
              onClick={() =>
                handleOpenHistorial(params.row.pagos_deudores, params.row.deudor)
              }
              sx={{
                cursor: "pointer",
                color: "#1976d2",
                "&:hover": { color: "#125ea9" }
              }}
            />
          </Box>
        );
      }
    },
     { field: "n_sesiones", headerName: "Sesiones", width: 100 },
    {
      field: "observaciones",
      headerName: "Mensaje",
      width: 120,
      renderCell: (params) =>
        params.value ? (
          <Button
            variant="contained"
            size="small"
            onClick={() => handleOpenDialog(params.value)}
            sx={{
              backgroundColor: "#6c63ff",
              textTransform: "none",
              fontFamily: "Poppins",
            }}
          >
            Ver
          </Button>
        ) : (
          ""
        ),
    },
    {
      field: "estado_paciente",
      headerName: "Estado",
      width: 150,
    },
    { field: "rut", headerName: "Rut", width: 120, renderCell: (params) => FormatRut(params.value) },
    { field: "prevision", headerName: "Previsión", width: 150 },
    { field: "monto", headerName: "Monto", width: 120, renderCell: (params) => formatCLP(params.value) },
    {
      field: "estado_pago",
      headerName: "Estado pago",
      width: 150,
      renderCell: (params) => (
        <Box
          sx={{
            px: 1.5,
            py: 0.5,
            borderRadius: "0px",
            color: params.value === "PROCESO"
              ? "#8b7b13ff"
              :
              params.value === "LIBERADO"
                ? "#a26009ff"
                :
                params.value === "NO PAGO"
                  ? "#600909ff"
                  : params.value === "PAGADO"
                    ? "#337d53f6"
                    : "#2e7d32",
            textAlign: 'center',
            backgroundColor:
              params.value === "PROCESO"
                ? "#f2d7279c"
                :
                params.value === "LIBERADO"
                  ? "#faa83d90"
                  :
                  params.value === "NO PAGO"
                    ? "#ff5e5e86"
                    : params.value === "PAGADO"
                      ? "#84f8b6f6"
                      : "#2e7d32",
            fontWeight: 600,
          }}
        >
          {params.value}
        </Box>
      ),
    },
     { field: "fecha_pago", headerName: "Fecha de pago", width: 150 },
    { field: "kine", headerName: "Kinesiólogo", width: 180 },
    { field: "medico_tratante", headerName: "Médico Tratante", width: 180 },
    {
      field: "sucursal",
      headerName: "Sucursal",
      width: 180,
    }
  ];


  const rowsSap = data?.sap?.map((item) => ({
    id: item.id,
    episodio: item.episodio,
    rut_paciente: item.rut_paciente,
    prevision: item.prevision,
    descripcion: item.descripcion || null,
    fecha_inicio_prestacion: item.fecha_inicio_prestacion,
    nombre_profesional: item.nombre_profesional,
    rut_profesional: item.rut_profesional,
    organizacion_gestora: item.organizacion_gestora,
    valor_bruto: item.valor_bruto,
    valor_exento: item.valor_exento,
    valor_neto: item.valor_neto,
  })) || [];

  const columnsSap = [
    {
      field: "fecha_inicio_prestacion",
      headerName: "Fecha Inicio",
      width: 150
    },
    { field: "episodio", headerName: "Episodio", width: 140 },

    {
      field: "rut_paciente",
      headerName: "RUT Paciente",
      width: 150,
      renderCell: (params) => FormatRut(params.value),
    },

    { field: "prevision", headerName: "Previsión", width: 180 },

    {
      field: "descripcion",
      headerName: "Mensaje",
      width: 180,
      renderCell: (params) =>
        params.value ? (
          <Button
            variant="outlined"
            size="small"
            onClick={() => handleOpenDialog(params.value)}
            sx={{
              borderColor: "#ffaa00",
              color: "#aa6b00",
              fontFamily: "Poppins",
              textTransform: "none",
            }}
          >
            Ver
          </Button>
        ) : (
          ""
        ),
    },


    {
      field: "nombre_profesional",
      headerName: "Profesional",
      width: 250,
    },

    {
      field: "rut_profesional",
      headerName: "RUT Profesional",
      width: 150,
      renderCell: (params) => FormatRut(params.value),
    },

    {
      field: "organizacion_gestora",
      headerName: "Organización",
      width: 150,
    },

    {
      field: "valor_bruto",
      headerName: "Bruto",
      width: 120,
      renderCell: (params) =>
        `$${Number(params.value).toLocaleString("es-CL")}`,
    },

    {
      field: "valor_exento",
      headerName: "Exento",
      width: 120,
      renderCell: (params) =>
        `$${Number(params.value).toLocaleString("es-CL")}`,
    },

    {
      field: "valor_neto",
      headerName: "Neto",
      width: 120,
      renderCell: (params) =>
        `$${Number(params.value).toLocaleString("es-CL")}`,
    },
  ];


  const capitalizarNombre = (nombre = "") => {
    return nombre
      .toLowerCase()
      .split(" ")
      .map(p => p.charAt(0).toUpperCase() + p.slice(1))
      .join(" ");
  };
  


const handleBusquedaGeneral = () => {
  if (!data) return;

  const query = busqueda.trim().toLowerCase();

  // 🔎 FILTRAR INGRESOS (deuda entra siempre)
  const ingresosFiltrados = (data.ingresos || []).filter(i => {
    const tieneDeuda = i.deudor?.estado === "DEUDA";

    if (tieneDeuda) return true;

    return (
      i.paciente?.episodio?.toLowerCase()?.includes(query) ||
      i.paciente?.fecha_pago?.toLowerCase()?.includes(query) ||
      i.paciente?.nombre_paciente?.toLowerCase()?.includes(query)
    );
  });

  // 🔎 FILTRAR SAP
  const sapFiltrado = (data.sap || []).filter(s =>
    s.episodio?.toLowerCase()?.includes(query) ||
    s.fecha_inicio_prestacion?.toLowerCase()?.includes(query)
  );

  const agrupado = {};

  // ================= AGRUPAR INGRESOS =================
  ingresosFiltrados.forEach(i => {

    // 🔥 NO usar ||
    const ep =
      i.paciente?.episodio !== undefined &&
      i.paciente?.episodio !== null
        ? String(i.paciente.episodio)
        : `SIN_EP_${i.paciente.id}`;

    if (!agrupado[ep]) {
      agrupado[ep] = {
        episodio: i.paciente?.episodio ?? null,
        ingresos: [],
        sap: []
      };
    }

    agrupado[ep].ingresos.push(i);
  });

  // ================= AGRUPAR SAP =================
  sapFiltrado.forEach(s => {

    const ep =
      s.episodio !== undefined && s.episodio !== null
        ? String(s.episodio)
        : null;

    if (!ep) return;

    if (!agrupado[ep]) {
      agrupado[ep] = {
        episodio: ep,
        ingresos: [],
        sap: []
      };
    }

    agrupado[ep].sap.push(s);
  });

  const resultado = Object.values(agrupado);



  setDetalleGeneral(resultado);
};



// 🔥 FUNCION PARA AGRUPAR EPISODIOS ÚNICOS
const episodiosUnicos = useMemo(() => {
  if (!detalleGeneral) return [];

  const agrupado = {};

  detalleGeneral.forEach((item) => {
    const ep = item.episodio || "SIN_EPISODIO";

    if (!agrupado[ep]) {
      agrupado[ep] = {
        episodio: ep,
        esDeudaSinEpisodio: item.esDeudaSinEpisodio || false,
        ingresos: [],
        sap: []
      };
    }

    // ================= INGRESOS =================
    item.ingresos?.forEach((ing) => {
      const existe = agrupado[ep].ingresos.some(
        (i) => i.paciente?.id === ing.paciente?.id
      );

      if (!existe) {
        agrupado[ep].ingresos.push(ing);
      }
    });

    // ================= SAP =================
    item.sap?.forEach((s) => {
      const existe = agrupado[ep].sap.some(
        (sapItem) => sapItem.id === s.id
      );

      if (!existe) {
        agrupado[ep].sap.push(s);
      }
    });
  });

  // 🔥 ORDENAR TODO ANTES DE RETORNAR
  Object.values(agrupado).forEach((grupo) => {

    grupo.ingresos.sort((a, b) => {
      const fechaA = new Date(a.paciente?.fecha_pago || a.paciente?.fecha);
      const fechaB = new Date(b.paciente?.fecha_pago || b.paciente?.fecha);
      return fechaA - fechaB;
    });

    grupo.sap.sort((a, b) => {
      const fechaA = new Date(a.fecha_inicio_prestacion);
      const fechaB = new Date(b.fecha_inicio_prestacion);
      return fechaA - fechaB;
    });

  });

  return Object.values(agrupado);

}, [detalleGeneral]);







  if (loading)
    return (
      <Box display="flex" justifyContent="center" mt={4} sx={styleCarga}>
        <CircularProgress />
      </Box>
    );
  return (
    <Container maxWidth="xl">
      <Paper
        elevation={3}
        sx={{
          p: 3,
          backgroundColor: "#fff",
          borderRadius: "16px",
          minHeight: "80vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* 🔹 Título */}
        <Box display="flex" alignItems="center" gap={2} mb={4}>
          <img
            src={Logocolor}
            alt="Logo Clínica Activa"
            style={{ width: 55, height: 55, objectFit: "contain" }}
          />
          <Typography variant="h5" sx={{ ...TituloPrincipal, textTransform: "none" }}>
            Resumen Paciente {capitalizarNombre(data?.ingresos[0].paciente?.nombre_paciente)}
          </Typography>

        </Box>
        {!esRolLimitado && (
    
        <Box>
          <Button
  variant="contained"
  sx={{
    mb: 3,
    backgroundColor: "#1976d2",
    fontFamily: "Poppins",
    textTransform: "none"
  }}
  onClick={handleOpenGeneral}
>
  Ver Información General
</Button>

        </Box>
        )}
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, sm: 6, md: 7 }}>
            <Box>
              {/* CARD DEL PACIENTE */}
              <Card
                elevation={4}
                sx={{
                  p: 3,
                  mb: 4,
                  borderRadius: "16px",
                  background: "#f9fafc",
                }}
              >
                <Grid container spacing={3} alignItems="center">

                  {/* Avatar grande */}
                  <Grid size={{ xs: 12, sm: 3, md: 2 }} display="flex" justifyContent="center">
                    <Avatar
                      sx={{
                        width: 100,
                        height: 100,
                        bgcolor: "#6c63ff",
                        fontSize: "2.5rem",
                      }}
                    >
                      {data?.ingresos[0]?.paciente?.nombre_paciente?.charAt(0)}
                    </Avatar>
                  </Grid>

                  {/* Datos del paciente */}
                  <Grid size={{ xs: 12, sm: 9, md: 10 }} >
                    <Typography variant="h5" sx={{ fontFamily: 'Poppins', color: '#585857', fontWeight: 600, mb: 1 }}>
                      {capitalizarNombre(data?.ingresos[0].paciente?.nombre_paciente)}
                    </Typography>

                    <Grid container spacing={2}>
                      {/* RUT */}
                      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <Typography sx={{ fontWeight: 600, fontFamily: 'Poppins', color: '#585857', }}>RUT:</Typography>
                        <Typography sx={{ fontFamily: 'Poppins', color: '#585857', }}>{FormatRut(data?.ingresos[0]?.paciente?.rut)}</Typography>
                      </Grid>

                      {/* Previsión */}
                      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <Typography sx={{ fontWeight: 600, fontFamily: 'Poppins', color: '#585857', }}>Previsión:</Typography>
                        <Typography sx={{ fontFamily: 'Poppins', color: '#585857', }}>{data?.ingresos[0]?.paciente?.prevision}</Typography>
                      </Grid>

                      {/* ¿Es deudor? */}
                      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <Typography sx={{ fontWeight: 600, fontFamily: 'Poppins', color: '#585857', }}>Estado Deuda:</Typography>

                        {data?.ingresos.some(i => i.paciente.estado_pago === "NO PAGO" || i.paciente.estado_pago === "PROCESO")
                          ? (
                            // 🔴 CON DEUDA
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                px: 2,
                                py: 0.5,
                                background: "#ffe0e0",
                                borderRadius: "20px",
                                color: "#b71c1c",
                                fontFamily: 'Poppins',
                                fontWeight: 600,
                                width: "fit-content",
                              }}
                            >
                              <WarningAmberIcon fontSize="small" />
                              Con Deuda
                            </Box>
                          )
                          : data?.ingresos.some(i => i.paciente.estado_pago === "LIBERADO")
                            ? (
                              // 🟡 EN PROCESO
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                  px: 2,
                                  py: 0.5,
                                  background: "#fff4cc",
                                  borderRadius: "20px",
                                  color: "#bb8a00",
                                  fontFamily: 'Poppins',
                                  fontWeight: 600,
                                  width: "fit-content",
                                }}
                              >
                                <WarningAmberIcon fontSize="small" />
                                En proceso
                              </Box>
                            )
                            : (
                              // 🟢 SIN DEUDA
                              <Box
                                sx={{
                                  px: 2,
                                  py: 0.5,
                                  background: "#e5ffe5",
                                  borderRadius: "20px",
                                  color: "#1b5e20",
                                  fontWeight: 600,
                                  width: "fit-content",
                                  fontFamily: 'Poppins'
                                }}
                              >
                                Sin deuda
                              </Box>
                            )
                        }

                      </Grid>
                    </Grid>
                  </Grid>

                </Grid>
              </Card>

            </Box>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 5 }}>
            <Box>
              {totalDeudaPaciente > 0 && (
                <Card
                  elevation={4}
                  sx={{
                    p: 3,
                    mb: 4,
                    borderRadius: "16px",
                    background: "#fff5f5",
                    border: "1px solid #ffb5b5",
                  }}
                >
                  <Grid container alignItems="center">

                    <Grid item xs={12} sm={2} display="flex" justifyContent="center">
                      <WarningAmberIcon sx={{ fontSize: 45, color: "#c62828" }} />
                    </Grid>

                    <Grid item xs={12} sm={10}>
                      <Typography
                        variant="h6"
                        sx={{ fontFamily: "Poppins", color: "#c62828", fontWeight: 700 }}
                      >
                        Deuda Total del Paciente
                      </Typography>

                      <Typography
                        sx={{ fontFamily: "Poppins", fontSize: "1.7rem", color: "#b71c1c", fontWeight: 700 }}
                      >
                        {formatCLP(totalDeudaPaciente)}
                      </Typography>

                      <Typography sx={{ fontFamily: "Poppins", color: "#8a0000" }}>
                        Suma de todos los saldos pendientes en sus ingresos.
                      </Typography>
                    </Grid>

                  </Grid>
                </Card>
              )}

            </Box>
          </Grid>
        </Grid>

        {/* TABLA DE INGRESOS */}
        <Box sx={{ height: 400, width: "100%", mt: 4 }}>
          <Typography variant="h6" sx={{ ...TituloPrincipal, mb: 3 }}>
            Ingresos del paciente
          </Typography>

          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={5}
             initialState={{
              sorting: {
                sortModel: [{ field: 'fecha', sort: 'asc' }],
              },
            }}
            rowsPerPageOptions={[5]}
            slots={{ noRowsOverlay: DiseñoDataGrid }}
            sx={{
              fontFamily: 'Poppins, sans-serif',
              '& .MuiDataGrid-columnHeaders': {
                color: '#113e21ff',
                fontWeight: 600,
                textTransform: 'capitalize',
              },
              '& .MuiDataGrid-cell': {
                textTransform: 'capitalize',
              },
            }}
          />
        </Box>
        {!esRolLimitado && (
    
        <Box>
          {/* TABLA SAP */}
          <Box sx={{ mt: 10 }}>
            <Typography variant="h6" sx={{ ...TituloPrincipal, mb: 3 }}>
              Información SAP
            </Typography>

            <DataGrid
              rows={rowsSap}
              columns={columnsSap}
              pageSize={5}
              rowsPerPageOptions={[5]}
              slots={{ noRowsOverlay: DiseñoDataGrid }}
              sx={{
                fontFamily: 'Poppins, sans-serif',
                '& .MuiDataGrid-columnHeaders': {
                  color: '#113e21ff',
                  fontWeight: 600,
                  textTransform: 'capitalize',
                },
                '& .MuiDataGrid-cell': {
                  textTransform: 'capitalize',
                },
              }}
            />
          </Box>

        </Box>
        )}
        {!esRolLimitado && (
    
        <Grid container>
          <Grid size={{ xs: 12, sm: 6 }}>
            {profesionalesAtendidos.length > 0 && (
              <Box mt={4}>
                <Typography
                  variant="h6"
                  sx={{ ...TituloPrincipal, mb: 3 }}
                >
                  Profesionales que han atendido al paciente
                </Typography>

                <Paper elevation={3} sx={{ padding: 2 }}>
                  <DataGrid
                    rows={profesionalesAtendidos}
                    columns={columnsProfesionales}
                    autoHeight
                    pageSizeOptions={[5, 10]}
                  />
                </Paper>
              </Box>
            )}
          </Grid>

        </Grid>
        )}
      </Paper>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={TituloPrincipal}>
          Información
        </DialogTitle>

        <DialogContent dividers>
          <Typography sx={SubTitulo}>
            {capitalizarNombre(dialogText)}
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setOpenDialog(false)}
            sx={buttonCancelar}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openHistorial}
        onClose={handleCloseHistorial}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            fontFamily: "Poppins",
            fontWeight: 600,
            color: "#2e8b78", // Verde oscuro
            borderBottom: "1px solid #dce9e6",
          }}
        >
          Historial de Pagos del Deudor
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            backgroundColor: "#f8fffd", // tono muy suave verde agua
            fontFamily: "Poppins",
            p: 3
          }}
        >

          {/* ====== RESUMEN DE DEUDA ====== */}
          {deudorSeleccionado && (
            <Box
              sx={{
                background: "#f4f9f8ff", // verde agua claro
                p: 2.5,
                borderRadius: "14px",
                mb: 3,
                boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.08)",
                border: "1px solid #cdece5"
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontWeight: 600,
                  fontSize: "1.1rem",
                  color: "#585857",
                  mb: 1.5
                }}
              >
                Resumen de Deuda
              </Typography>

              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography sx={{ fontFamily: 'Poppins', color: "#2e8b78", fontWeight: 600 }}>
                    Total Deuda:
                  </Typography>
                  <Typography sx={{ fontWeight: 500, fontFamily: 'Poppins', }}>
                    ${parseInt(deudorSeleccionado.total_deuda).toLocaleString("es-CL")}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography sx={{ fontFamily: 'Poppins', color: "#2e8b78", fontWeight: 600 }}>
                    Saldo Restante:
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontWeight: 600,
                      color: "#651313ff" // rojo suave
                    }}
                  >
                    ${parseInt(deudorSeleccionado.saldo_restante).toLocaleString("es-CL")}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          )}

          {/* ======= DATA GRID DEL HISTORIAL ======= */}
          <Box sx={{ height: 320, width: "100%" }}>
            <DataGrid
              rows={
                historialSeleccionado?.map((pago, index) => ({
                  id: pago.id || index,
                  episodios: pago.episodios,
                  sesiones_pagadas: pago.sesiones_pagadas,
                  monto_pagado: pago.monto_pagado,
                  fecha_pago: pago.fecha_pago,
                })) || []
              }
              columns={[
                { field: "episodios", headerName: "Episodio", width: 150 },
                { field: "sesiones_pagadas", headerName: "Sesiones Pagadas", width: 180 },
                {
                  field: "monto_pagado",
                  headerName: "Monto Pagado",
                  width: 160,
                  renderCell: (params) =>
                    `$${parseInt(params.value).toLocaleString("es-CL")}`,
                },
                { field: "fecha_pago", headerName: "Fecha Pago", width: 150 },
              ]}
              pageSize={5}
              rowsPerPageOptions={[5]}
              disableSelectionOnClick
              sx={{
                fontFamily: "Poppins",
                background: "#ffffff",
                borderRadius: "10px",
                boxShadow: "0px 2px 6px rgba(0,0,0,0.05)",
                border: "1px solid #d7eee9",

                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#d1f2eb",
                  color: "#2e8b78",
                  fontWeight: 700,
                  fontSize: "0.9rem",
                },

                "& .MuiDataGrid-row": {
                  "&:nth-of-type(even)": { backgroundColor: "#f4fbf9" },
                },

                "& .MuiDataGrid-cell": {
                  color: "#2e2e2e",
                  fontSize: "0.85rem"
                },
              }}
            />
          </Box>

        </DialogContent>

        <DialogActions
          sx={{
            borderTop: "1px solid #dce9e6",
            backgroundColor: "#f9fdfc",
            py: 1.5
          }}
        >
          <Button
            onClick={handleCloseHistorial}
            sx={{
              textTransform: "capitalize",
              fontFamily: "Poppins",
              backgroundColor: "#42c6a5",
              color: "#fff",
              px: 3,
              borderRadius: "10px",
              "&:hover": {
                backgroundColor: "#2e8b78",
              }
            }}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

  <Dialog
  open={openGeneralModal}
  onClose={() => setOpenGeneralModal(false)}
  maxWidth="xxl"
  fullWidth
>
  <DialogTitle sx={{ ...TituloPrincipal }}>
    Información General Asociada
  </DialogTitle>

  <DialogContent dividers>

    {/* === BUSCADOR === */}
    <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
      <TextField
        label="Buscar por Episodio o Fecha"
        variant="outlined"
        value={busqueda}
        onChange={(e) => setBusqueda(e.target.value)}
        sx={{ ...InputBuscador, width: 300 }}
        onKeyDown={(e) => {
          if (e.key === "Enter") handleBusquedaGeneral();
        }}
      />

      <Button
        variant="contained"
        sx={{ ...buttonGuardar }}
        onClick={handleBusquedaGeneral}
      >
        Buscar
      </Button>
    </Box>

    {/* ================= RESULTADOS ================= */}

    {!episodiosUnicos || episodiosUnicos.length === 0 ? (
  <Typography>No se encontró información.</Typography>
) : (
  episodiosUnicos.map((d) => {

    // ===== ORDENAR SIN MUTAR =====
    const ingresosOrdenados = [...(d.ingresos || [])]
      .sort((a, b) =>
        new Date(a.paciente.fecha_pago) -
        new Date(b.paciente.fecha_pago)
      );

    const sapOrdenados = [...(d.sap || [])]
      .sort((a, b) =>
        new Date(a.fecha_inicio_prestacion) -
        new Date(b.fecha_inicio_prestacion)
      );
      const tieneDeuda = ingresosOrdenados.some(
  (i) => i.deudor?.estado === "DEUDA"
);



    return (
      <Paper
  key={d.episodio || `deuda-${d.ingresos?.[0]?.paciente?.id}`}
  elevation={3}
  sx={{
    p: 3,
    mb: 4,
    borderRadius: 3,
    background: tieneDeuda ? "#ffe5e5" : "#fafafa",
    border: tieneDeuda ? "2px solid #dc3545" : "none"
  }}
>


        {/* HEADER */}
       <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>

  {tieneDeuda ? (
    <ErrorIcon sx={{ color: "#dc3545", fontSize: 28 }} />
  ) : (
    getEstadoIcon(ingresosOrdenados?.[0]?.estado_pago)
  )}

  <Typography sx={{ fontFamily: "Poppins", fontSize: 16 }}>
    {d.episodio && d.episodio !== "0" ? (
      <>
        Episodio <strong>{d.episodio}</strong>
        {tieneDeuda && (
          <span style={{ color: "#dc3545", marginLeft: 8 }}>
            — Con Deuda
          </span>
        )}
      </>
    ) : (
      <strong style={{ color: tieneDeuda ? "#dc3545" : "#333" }}>
        Ingreso realizado {tieneDeuda && "— Con Deuda"}
      </strong>
    )}
  </Typography>

</Box>


        <Grid container spacing={3}>

          {/* INGRESO PACIENTE */}
          <Grid size={{xs:12, md:6}}>
            <Paper
              variant="outlined"
              sx={{
                borderRadius: 3,
                height: 380,
                display: "flex",
                flexDirection: "column",
                p: 2
              }}
            >
              <Typography sx={{ fontWeight: 600, mb: 2 }}>
                Ingreso Paciente
              </Typography>

              {ingresosOrdenados.length > 0 ? (
                <TableContainer sx={{ flex: 1, overflowY: "auto" }}>
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow >

                        <TableCell>Fecha</TableCell>
                        <TableCell>Paciente</TableCell>
                        <TableCell>Monto</TableCell>
                        <TableCell>Sesiones</TableCell>
                        <TableCell>Previsión</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {ingresosOrdenados.map((i) => (
                       <TableRow
  key={i.paciente.id}
  sx={{
    backgroundColor:
      i.deudor?.estado === "DEUDA" ? "#ffe5e5" : "inherit",
    borderLeft:
      i.deudor?.estado === "DEUDA"
        ? "4px solid #dc3545"
        : "none"
  }}
>

                          <TableCell>{i.paciente.fecha_pago}</TableCell>
                          <TableCell>{i.paciente.nombre_paciente}</TableCell>
                          <TableCell>{formatCLP(i.paciente.monto)}</TableCell>
                          <TableCell>{i.paciente.n_sesiones}</TableCell>
                          <TableCell>{i.paciente.prevision}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Box sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Typography>No se encontró información.</Typography>
                </Box>
              )}
            </Paper>
          </Grid>

          {/* SAP */}
          <Grid size={{xs:12, md:6}}>
            <Paper
              variant="outlined"
              sx={{
                borderRadius: 3,
                height: 380,
                display: "flex",
                flexDirection: "column",
                p: 2
              }}
            >
              <Typography sx={{ fontWeight: 600, mb: 2 }}>
                SAP
              </Typography>

              {sapOrdenados.length > 0 ? (
                <TableContainer sx={{ flex: 1, overflowY: "auto" }}>
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Fecha inicio</TableCell>
                        <TableCell>Profesional</TableCell>
                        <TableCell>Valor Neto</TableCell>
                        <TableCell>Previsión</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {sapOrdenados.map((s) => (
                        <TableRow key={s.id}>
                          <TableCell>{s.fecha_inicio_prestacion}</TableCell>
                          <TableCell>{s.nombre_profesional}</TableCell>
                          <TableCell>{formatCLP(s.valor_neto)}</TableCell>
                          <TableCell>{s.prevision}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Box sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Typography>No se encontró información.</Typography>
                </Box>
              )}
            </Paper>
          </Grid>

        </Grid>
      </Paper>
    );
  })
)}


  </DialogContent>

  <DialogActions>
    <Button sx={buttonCancelar} onClick={() => setOpenGeneralModal(false)}>
      Cerrar
    </Button>
  </DialogActions>
</Dialog>





    </Container>

  );
};

export default BuscarPacienteIndex;
